export default {"src":"/_next/static/media/arrowDownDark.f78b4ed6.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};